export const firebaseConfig = {
  apiKey: "AIzaSyB5m_AnO575kvWriahcF1SFIWp8Fj3gQno",
  authDomain: "auth.monkeytype.com",
  databaseURL: "https://monkey-type.firebaseio.com",
  projectId: "monkey-type",
  storageBucket: "monkey-type.appspot.com",
  messagingSenderId: "789788471140",
  appId: "1:789788471140:web:7e31b15959d68ac0a51471",
  measurementId: "G-PFV65WPEWF",
};
